import React, {Fragment, useEffect, useMemo, useState} from 'react';
import axios from "axios";
import styles from './openness.module.scss';
import Select, {components} from 'react-select';
// import {opennessData} from '../../data/data-openness';
import CountryFlag from '../common/countryFlag/country-flag';
import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import IconSearch from '../common/icon/icon-search';
import IconDelete from '../common/icon/icon-delete';
import {applySortFilter, getComparator, rankSuffix, capitalizingWords} from "../../utils/utils";
import SortableColumn from "../common/sortableColumn/SortableColumn";
import {useIsMobile900} from '../../hooks/mobile';

const options = [
    {label: "Openness Rank and Score", value: "opennessRank"},
    {label: "HPI Rank and Score", value: "HPIRank"},
    {label: "Openness %", value: "opennessPercentage"},
    {label: "HPI %", value: "HPIPercentage"}
];

let baseApiUrl = "https://api.henleypassportindex.com/api/";

if (window['__hpi_url__'] !== undefined) {
    baseApiUrl = window['__hpi_url__'];
}


const dropDownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <IconSearch />
            </components.DropdownIndicator>
        )
    );
};


const Openness = () => {
    const [passport, setPassport] = useState('');
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('opennessRank');
    const [display, setDisplay] = useState();
    const isMobile = useIsMobile900();
    const [opennessData, setOpennessData] = useState(null);
    const data_url = `${baseApiUrl}v3/openness`;
    
    
    const fetchData = async () => {
      const requestData  = await axios.get(data_url);
      setOpennessData(requestData.data);
    };
    
    useEffect(() => {
      fetchData();
    }, []);
    
    const handleOptionSelect = (option) => {
        setOrderBy(option.value);
        setDisplay(-1);
    };

    const handleSort = (columnName) => {
        if(orderBy === columnName) {
            setOrder(order === 'asc' ? 'desc' : 'asc');
        }
        setOrderBy(columnName);
        setDisplay(-1);
    };
    
    // sor the data based on the `orderBy` value
    const data = useMemo(() => {
        //note: this is a special case when Percentage are involved with the ordering
        let sortOrder = order;
        if(orderBy === 'opennessPercentage' || orderBy==='HPIPercentage') {
            sortOrder = (order === 'asc') ? 'desc' : 'asc'
        }

        return (opennessData === null) ? null : applySortFilter({
            data: opennessData,
            comparator: getComparator(sortOrder, orderBy),
            searchTerm: passport,
            filterColumn: 'country'
        });
    }, [opennessData, passport, orderBy, order]);


    // sor the data based on the `orderBy` value
    const passports = useMemo(() => {
        return (opennessData === null) ? null : opennessData.map((item) => ({
            label: item.country,
            value: item.country
        }));
    }, [opennessData]);

    const handlePassportSelect = (selectedOption) => {
        if(selectedOption === null) {
            setPassport("");
        } else {
            setPassport(selectedOption.value);
        }
    }

    const handlePassportClear = () => {
        setPassport("");
    }

    const handleMobileRowClick = (index) => {
        setDisplay(index);
    }
    

    //todo: @noods  this needs to be moved to the scss
    const passportSelectStyles = {
        menu: (provided) => ({
            ...provided,
            zIndex: 100,
            backgroundColor:'#fff',
            borderRadius: 0,
            paddingLeft: 10,
            paddingRight: 10
        }),
        control: (provided) => ({
            ...provided,
            background: "transparent",
            border: "none",
            boxShadow: "none",
            borderRadius: 0,
            color: "#405363",
            padding:0,
            borderBottom: "1px solid #979797"
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: "#405363",
            padding: isMobile ? 14 : 12,
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#405363",
            fontFamily: "Garamond Regular",
            fontSize: isMobile ? 14: 16,
            //   paddingLeft: 16,
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            display: "none",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#405363",
            fontFamily: "Garamond Regular",
            fontSize: isMobile ? 14 : 16,
            //   paddingLeft: 10,
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: "0 0 8px 0",

        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            background: "#f7f7f7",
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: isMobile ? 14 : 18,
            backgroundColor: state.isFocused
                ? "#C1C5C8"
                : state.isDisabled
                    ? "#f3f3f3"
                    : null,
            color: state.isFocused
                ? "#405363"
                : state.isDisabled
                    ? "#405363"
                    : "",
            opacity: state.isDisabled
                ? "0.5"
                : "1",
            cursor: state.isDisabled
                ? 'not-allowed'
                : 'pointer'
        }),
    };
    
    
    useEffect(() => {
        console.debug('watch searchTerm:', passport);
    }, [passport])

    return (
        <>
            <div className={`d-md-none ${styles.sortMobileWrapper}`}>
                <div className={styles.sortTitle}>Sort by</div>
                <SelectDropdown options={options} onSelect={handleOptionSelect}/>
            </div>
            <table className={`chartTable ${styles.table} ${styles.opennessChartTable}`}>
                <thead>
                <tr className={styles.cellHideMobile}>
                    <th className={styles.headerColumn} colSpan="2">Passport</th>
                    <th className={styles.headerColumn} colSpan="2">Openness</th>
                    <th className={styles.headerColumn} colSpan="2">Henley Passport Index</th>
                    <th className={styles.headerColumn}>&nbsp;</th>
                </tr>

                <tr>
                    <th className={styles.countryColumn}>
                        <Select
                            value={passport}
                            options={passports}
                            onChange={handlePassportSelect}
                            isClearable
                            isSearchable
                            placeholder="Search for a passport"
                            components={{ DropdownIndicator:dropDownIndicator}}
                            blurInputOnSelect={true}
                            styles={passportSelectStyles}
                        />
                    </th>
                    <SortableColumn column="region" handleSort={handleSort} orderBy={orderBy} order={order} styles={styles} >
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>Region</span>
                            <IconSort/>
                        </div>
                    </SortableColumn>
                    <SortableColumn column="opennessRank" handleSort={handleSort} orderBy={orderBy} order={order} styles={styles} classes={`${styles.noBorderRight}`}>
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>Openness <br
                                className={styles.cellHideMobile}/>Rank</span>
                            <IconSort/>
                        </div>
                    </SortableColumn>
                    <th className={`text-left ${styles.cellHideMobile} ${orderBy === 'opennessRank' ? styles.selectedColumn : ''}`}>
                        Openness Score <br/>(out of 198)
                    </th>
                    <SortableColumn column="HPIRank" handleSort={handleSort} orderBy={orderBy} order={order} styles={styles} classes={`${styles.noBorderRight}`}>
                        <div className={styles.sortColumnTitle}>
                            <span className={styles.sortColumnTitleText}>HPI Rank</span>
                            <IconSort/>
                        </div>
                    </SortableColumn>
                    <th className={`text-left ${styles.cellHideMobile}  ${orderBy === 'HPIRank' ? styles.selectedColumn : ''}`}>
                        HPI Score <br/>(out of 226)
                    </th>
                    <th className={`text-left ${styles.cellHideMobile}  ${(orderBy === 'opennessPercentage' || orderBy === 'HPIPercentage') ? styles.selectedColumn : ''}`}>
                        <div className={styles.legend}><div className={`${styles.legendBox} ${styles.darkBlue}`}></div> Openness %</div>
                        <div className={styles.legend}><div className={`${styles.legendBox} ${styles.lightBlue}`}></div> HPI %</div>
                    </th>
                </tr>
                </thead>
                {/* {data !== null && */}
                <tbody>
                {data !== null && data.map((item, index) => (
                    <Fragment key={index}>
                        <tr onClick={() => handleMobileRowClick(index)}
                            className={`${styles.contentRow}`}>
                            <td className={styles.cellCountry}>
                                <div className={styles.displayFlex}>
                                    {passport === item.country ? (
                                        <button className={styles.deleteRowButton} onClick={() => handlePassportClear()}>
                                            <IconDelete />
                                        </button>
                                    ):''}

                                    <CountryFlag iso={item.iso} country={item.country} region={item.region}/>
                                </div>
                            </td>
                            <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${orderBy === 'region' ? styles.selectedColumn : ''} ${styles.smallColumn}`}>
                                {capitalizingWords(item.region)}
                            </td>
                            <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${orderBy === 'opennessRank' ? styles.selectedColumn : ''} ${styles.extraSmallColumn}`}>
                                {rankSuffix(item.opennessRank)}
                            </td>
                            <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${orderBy === 'opennessRank' ? styles.selectedColumn : ''} ${styles.extraSmallColumn}`}>
                                {item.opennessScore}
                            </td>
                            <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${orderBy === 'HPIRank' ? styles.selectedColumn : ''} ${styles.extraSmallColumn}`}>
                                {rankSuffix(item.HPIRank)}
                            </td>
                            <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${orderBy === 'HPIRank' ? styles.selectedColumn : ''} ${styles.extraSmallColumn}`}>
                                {item.HPIScore}
                            </td>
                            <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${(orderBy === 'opennessPercentage' || orderBy === 'HPIPercentage') ? styles.selectedColumn : ''} ${styles.percentColumn}`}>
                                <ProgressBar
                                    percentValue={item.opennessPercentage}
                                    labelText={item.opennessPercentage + "%"}
                                    colour={'#405363'}
                                />

                                <ProgressBar
                                    percentValue={item.HPIPercentage}
                                    labelText={item.HPIPercentage + "%"}
                                    colour={'#6EA7D8'}
                                />
                            </td>
                        </tr>

                    </Fragment>
                ))}
                </tbody>
              
            </table>
        </>
    )
}

export default Openness;